module.exports = __webpack_public_path__ + "img/icon_black_fork_knife.1c1dbd70.svg";